// [COMEMORATIVO-COPA] CSS do banner, injetado em runtime num <style> dedicado
// (ver index.js). Todas as classes/keyframes usam prefixo `cmm-copa-` para não
// colidir com o restante do sistema. Nada é adicionado ao bundle global.
//
// Direção estética: "transmissão da Copa" — base esmeralda→navy, holofote
// dourado, raios giratórios, confete nas cores do Brasil, bola com sombra e
// título display (Anton) com brilho dourado em movimento.
export default `
@import url("https://fonts.googleapis.com/css2?family=Anton&display=swap");

.cmm-copa-banner {
  position: fixed;
  left: 0;
  width: 100%;
  height: 76px;
  z-index: 2147483000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background:
    radial-gradient(
      130% 200% at 50% -55%,
      rgba(255, 223, 0, 0.28),
      transparent 55%
    ),
    linear-gradient(110deg, #012a1a 0%, #02502e 44%, #012a5e 100%);
  font-family: -apple-system, "Segoe UI", Roboto, sans-serif;
}

/* Posição: topo */
.cmm-copa--top {
  top: 0;
  box-shadow: 0 6px 26px rgba(0, 0, 0, 0.45);
  animation: cmm-copa-slidein-top 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.cmm-copa--top.cmm-copa-out {
  animation: cmm-copa-fadeout-top 0.6s ease forwards;
}

/* Posição: rodapé */
.cmm-copa--bottom {
  bottom: 0;
  box-shadow: 0 -6px 26px rgba(0, 0, 0, 0.45);
  animation: cmm-copa-slidein-bottom 0.65s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.cmm-copa--bottom.cmm-copa-out {
  animation: cmm-copa-fadeout-bottom 0.6s ease forwards;
}

.cmm-copa-banner::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(
    90deg,
    #009c3b,
    #ffdf00,
    #ffffff,
    #ffdf00,
    #009c3b
  );
  background-size: 200% 100%;
  animation: cmm-copa-flow 2.2s linear infinite;
}

/* A faixa de destaque fica na borda oposta à tela. */
.cmm-copa--top::after {
  bottom: 0;
}

.cmm-copa--bottom::after {
  top: 0;
}

.cmm-copa-glow {
  position: absolute;
  left: 50%;
  width: 540px;
  height: 540px;
  transform: translateX(-50%);
  background: radial-gradient(
    circle,
    rgba(255, 223, 0, 0.38),
    transparent 62%
  );
  filter: blur(4px);
  animation: cmm-copa-bloom 1s ease both;
}

/* O holofote floresce a partir da borda da tela. */
.cmm-copa--top .cmm-copa-glow {
  top: -62%;
}

.cmm-copa--bottom .cmm-copa-glow {
  bottom: -62%;
}

.cmm-copa-rays {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 240%;
  height: 620px;
  transform: translate(-50%, -50%);
  background: repeating-conic-gradient(
    from 0deg,
    rgba(255, 255, 255, 0.06) 0deg 6deg,
    transparent 6deg 17deg
  );
  opacity: 0.45;
  mix-blend-mode: screen;
  animation: cmm-copa-spin 18s linear infinite;
}

.cmm-copa-confetti {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.cmm-copa-confete {
  position: absolute;
  top: -16px;
  display: block;
  width: 8px;
  height: 8px;
  opacity: 0;
  border-radius: 2px;
  animation-name: cmm-copa-fall;
  animation-timing-function: ease-in;
  animation-iteration-count: infinite;
}

.cmm-copa-ball {
  position: absolute;
  left: 50%;
  bottom: 13px;
  font-size: 38px;
  line-height: 1;
  z-index: 1;
  filter: drop-shadow(0 6px 6px rgba(0, 0, 0, 0.5));
  animation: cmm-copa-roll 2.8s cubic-bezier(0.3, 0, 0.5, 1) forwards;
}

.cmm-copa-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 16px;
}

.cmm-copa-head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.cmm-copa-kicker {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.78);
  opacity: 0;
  transform: translateY(8px);
  animation: cmm-copa-up 0.6s ease 0.18s forwards;
}

.cmm-copa-title {
  font-family: "Anton", "Arial Narrow", Impact, sans-serif;
  font-weight: 400;
  font-size: 40px;
  line-height: 0.92;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  white-space: nowrap;
  background: linear-gradient(
    100deg,
    #ffffff 0%,
    #ffe45e 28%,
    #ffd000 52%,
    #ffffff 82%
  );
  background-size: 220% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  filter: drop-shadow(0 2px 0 rgba(0, 40, 118, 0.5));
  animation:
    cmm-copa-shine 2.4s linear infinite,
    cmm-copa-pop 0.7s cubic-bezier(0.2, 1.4, 0.4, 1) both;
}

.cmm-copa-local {
  margin-top: 3px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.62);
  white-space: nowrap;
  opacity: 0;
  transform: translateY(8px);
  animation: cmm-copa-up 0.6s ease 0.26s forwards;
}

.cmm-copa-flag {
  font-size: 34px;
  opacity: 0;
  transform: scale(0.6) rotate(-12deg);
  filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.4));
  animation: cmm-copa-flag-in 0.6s cubic-bezier(0.2, 1.5, 0.4, 1) 0.35s forwards;
}

@keyframes cmm-copa-slidein-top {
  from { transform: translateY(-100%); }
  to { transform: translateY(0); }
}

@keyframes cmm-copa-slidein-bottom {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

@keyframes cmm-copa-fadeout-top {
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(-100%); }
}

@keyframes cmm-copa-fadeout-bottom {
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(100%); }
}

@keyframes cmm-copa-flow {
  to { background-position: 200% 0; }
}

@keyframes cmm-copa-bloom {
  from { opacity: 0; transform: translateX(-50%) scale(0.6); }
  to { opacity: 1; transform: translateX(-50%) scale(1); }
}

@keyframes cmm-copa-spin {
  to { transform: translate(-50%, -50%) rotate(360deg); }
}

@keyframes cmm-copa-fall {
  0% { transform: translateY(-20px) rotate(0deg); opacity: 0; }
  12% { opacity: 1; }
  100% { transform: translateY(98px) rotate(560deg); opacity: 0; }
}

@keyframes cmm-copa-roll {
  from { transform: translateX(-60vw) rotate(0deg); }
  to { transform: translateX(60vw) rotate(900deg); }
}

@keyframes cmm-copa-up {
  to { opacity: 1; transform: translateY(0); }
}

@keyframes cmm-copa-pop {
  0% { opacity: 0; transform: translateY(10px) scale(0.9); }
  60% { opacity: 1; }
  100% { transform: translateY(0) scale(1); }
}

@keyframes cmm-copa-flag-in {
  to { opacity: 1; transform: scale(1) rotate(0deg); }
}

@media (max-width: 640px) {
  .cmm-copa-banner { height: 64px; }
  .cmm-copa-title { font-size: 28px; }
  .cmm-copa-kicker { letter-spacing: 0.28em; }
  .cmm-copa-ball { font-size: 30px; }
}
`;
